// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { ExpertProfile } from "redux/reducers/expertProfile";
import { RootSliceType } from "redux/reducers/rootReducer";

const useExpertProfileSelectors = () => {
  const expertProfile = useSelector<RootSliceType, ExpertProfile["profile"]>(
    (state) => state.expertProfile.profile
  );

  const isFormDisabled = useSelector<RootSliceType, ExpertProfile["isFormDisabled"]>(
    (state) => state.expertProfile.isFormDisabled
  );

  const formType = useSelector<RootSliceType, ExpertProfile["formType"]>(
    (state) => state.expertProfile.formType
  );

  const loading = useSelector<RootSliceType, ExpertProfile["loading"]>(
    (state) => state.expertProfile.loading
  );

  return {
    expertProfile,isFormDisabled, formType, loading
  };
};

export default useExpertProfileSelectors;
